<template>
  <div class="">
    <p class="top-header">
      Trucks
      <v-btn
        @click="initialize()"
        small
        class="text-capitalize float-right"
        color="primary"
        dark
        ><v-icon class="mr-2" small>mdi-refresh</v-icon
        >{{ $t("Reload") }}</v-btn
      >
    </p>
    <v-alert v-model="errorAlert" dismissible dense outlined type="error">
      <span> {{ errorMsg }} </span>
    </v-alert>
    <hr class="mb-3" />
    <div class="d-flex flex-row align-center justify-space-between mb-5">
    <v-btn
      small
      width="200"
      class="text-capitalize mb-2"
      color="primary"
      @click="openUploadFiles()"
      >+ Add Image</v-btn
    >
      <div class="d-flex flex-row align-center">
        <v-text-field
          @keydown.enter="initialize()"
          v-model="qSearch"
          solo
          dense
          flat
          label="Search Trucks ..."
          style="max-width: 250px; border-radius: 8px"
          hide-details
        >
          <img
            slot="prepend-inner"
            width="20px"
            height="20px"
            src="/icons/search.svg"
          />
        </v-text-field>
      </div>
    </div>
    <v-data-table
      :headers="headers"
      :items="trucks"
      :options.sync="options"
      :server-items-length="totalTrucks"
      :loading="loadingTable"
      :loading-text="`${$t('Loading')}... ${$t('PleaseWait')}`"
      :footer-props="footerProps"
    >
      <template v-slot:[`item.edit`]="{ item }">
<!--        <v-icon class="cursor&#45;&#45;pointer" @click="goToTruck(item)">-->
<!--          mdi-pencil-->
<!--        </v-icon>-->
        <v-icon
          class="cursor--pointer red--text ml-1"
          @click="setTruckToRemove(item._id)"
        >
          mdi-trash-can
        </v-icon>
      </template>

      {{ item }}

      <template v-slot:[`item.pictureUrls`]="{ item }">



        <div
          class="d-flex flex-column align-start dnd-container"
          v-if="item.pictureUrls"
        >
          <Container
            v-if="item.pictureUrls"
            class="d-flex align-center"
            orientation="horizontal"
            behaviour="contain"
            drag-class="opacity-ghost"
            drop-class="opacity-ghost-drop"
          >
              <v-img
                  v-for="(pictureItem, index) in trucks[productPos(item._id)].pictureUrls"
                  :key="index"
                :src="`${staticUrl}/${item._id}/${pictureItem}`"
                height="80"
                max-width="80"
                contain
                class="rounded ma-1"
              >
                <template v-slot:placeholder>
                  <v-row
                    class="fill-height ma-0"
                    align="center"
                    justify="center"
                  >
                    <v-progress-circular
                      indeterminate
                      color="grey"
                      size="32"
                    ></v-progress-circular>
                  </v-row>
                </template>
              </v-img>
          </Container>
        </div>
      </template>
    </v-data-table>

    {{/* Upload dialog */}}
    <v-dialog v-model="uploadFileDialog" max-width="500px">
      <v-card class="pa-3">
        <v-card-title>
          <div class="mb-3">
            <span class=""> Upload Pictures</span>
          </div>
          <v-spacer></v-spacer>
          <v-icon @click="closeUploadFilesDialog()">
            mdi-close
          </v-icon>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-form ref="form">
              <v-text-field
                  outlined
                  placeholder="Name"
                  v-model="selectedGalery.name"
              ></v-text-field>
              <v-file-input
                dense
                color="primary"
                v-model="selectedGalery.file"
                placeholder="Select your file(s)"
                outlined
              ></v-file-input>
            </v-form>

            {{/* Preview images */}}
            <v-slide-group v-if="uploadedImagePreview" show-arrows>
              <v-slide-item
                v-for="(imagePath, index) in uploadedImagePreview"
                :key="index"
              >
                <v-hover>
                  <v-img
                    :src="imagePath"
                    height="80"
                    max-width="80"
                    contain
                    class="rounded ma-1"
                  >
                    <template v-slot:placeholder>
                      <v-row
                        class="fill-height ma-0"
                        align="center"
                        justify="center"
                      >
                        <v-progress-linear color="blue" indeterminate rounded />
                      </v-row>
                    </template>
                  </v-img>
                </v-hover>
              </v-slide-item>
            </v-slide-group>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-btn
            outlined
            color="red darken-1"
            width="100"
            class="ml-5"
            dark
            @click="closeUploadFilesDialog()"
            >Cancel
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            outlined
            width="100"
            class="mr-5"
            :loading="sending"
            color="green darken-1"
            dark
            @click="uploadFiles()"
            >Send
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    {{/* Confirm image deletion dialog */}}
    <v-dialog
      v-model="dialogRemoveImage"
      max-width="320"
      :disabled="loadingRemoving"
      :persistent="loadingRemoving"
    >
      <v-card>
        <v-card-title class="headline">
          Remove this picture?
        </v-card-title>

        <v-img :src="imageToRemove" width="100%" height="auto">
          <template v-slot:placeholder>
            <v-row class="fill-height ma-0" align="center" justify="center">
              <v-progress-linear color="blue" indeterminate rounded />
            </v-row>
          </template>

          {{/* Loading removing */}}
          <v-row
            v-if="loadingRemoving"
            class="fill-height ma-0"
            align="center"
            justify="center"
          >
            <v-progress-circular color="blue" indeterminate rounded />
          </v-row>
        </v-img>

        <v-card-actions class="justify-end">
          <v-btn color="grey" text @click="dialogRemoveImage = false">
            cancel
          </v-btn>

          <v-btn
            color="error"
            :disabled="loadingRemoving"
            depressed
            @click="
              () =>
                removeImage(imageRemoveFrom.productId, imageRemoveFrom.index)
            "
          >
            remove
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    {{/* Confirm truck deletion */}}
    <v-dialog
      v-model="dialogRemoveTruck"
      max-width="320"
      :disabled="loadingRemovingTruck"
      :persistent="loadingRemovingTruck"
    >
      <v-card>
        <v-card-text class="pt-3">
          <div class="text-body-1">
            Do you want remove the image?
          </div>
          <v-progress-linear
            v-if="loadingRemovingTruck"
            class="my-2"
            indeterminate
            rounded
          />
        </v-card-text>
        <v-card-actions class="justify-end">
          <v-btn color="grey" text @click="dialogRemoveTruck = false">
            cancel
          </v-btn>

          <v-btn
            color="error"
            :disabled="loadingRemovingTruck"
            depressed
            @click="removeTruck"
          >
            remove
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import { vdataTable } from "@/plugins/vuetify-custom-props";
import RestResourceGalery from "../../api/apiGaleryService";
import * as axios from "axios";
// For drag and drop images
import { applyDrag } from "@/views/Truck/dragDropUtils";
import { Container } from "vue-smooth-dnd";
import { getAPI } from "@/api/axios-base";

export default {
  components: { Container },
  data() {
    return {
      serverUrl: process.env.VUE_APP_BASE_URL,
      staticUrl: process.env.VUE_APP_BASE_STATIC,
      loadingTable: false,
      options: {},
      footerProps: vdataTable.footerProps,
      totalTrucks: 0,
      pagination: {},
      errorAlert: false,
      errorMsg: "",
      selectedGalery: {
        _id: "",
        name: "",
        file: null
      },
      filterParams: {
        code: null
      },
      sending: false,
      uploadFileDialog: false,
      qSearch: null,
      headers: [
        {
          text: this.$t("Edit"),
          width: 150,
          align: "start",
          sortable: false,
          value: "edit"
        },
        {
          text: "Name",
          align: "start",
          width: 250,
          sortable: false,
          value: "name"
        },
        {
          text: "Image",
          align: "center",
          sortable: false,
          value: "pictureUrls"
        }
      ],
      trucks: [],
      dropPlaceholderOptions: {
        className: "drop-preview",
        animationDuration: "200",
        showOnTop: true
      },
      // Proceso de borrar imagenes
      dialogRemoveImage: false,
      imageToRemove: "",
      imageRemoveFrom: {
        productId: "",
        index: 0
      },
      loadingRemoving: false,

      // Proceso de borrar camiones
      truckToRemove: "",
      loadingRemovingTruck: false,
      dialogRemoveTruck: false
    };
  },
  computed: {
    uploadedImagePreview() {
      const result = [];
      if (this.selectedGalery.file) {
        result.push(URL.createObjectURL(this.selectedGalery.file));
      }
      return result;
    }
  },
  watch: {
    options: {
      handler() {
        this.initialize();
      },
      deep: true
    }
  },
  methods: {
    async initialize() {
      const { page, itemsPerPage } = this.options;
      this.loadingTable = true;
      const params = {
        ...this.filterParams,
        q: this.qSearch || null,
        skip: (page - 1) * itemsPerPage,
        limit: itemsPerPage
      };
      RestResourceGalery.prototype
        .getGalery(params)
        .then(resp => {
          this.trucks = resp.data.data;
          this.totalTrucks = resp.data.total;
        })
        .catch(error => {
          this.errorMsg = error.response.data.message;
          this.errorAlert = true;
        })
        .finally(() => {
          this.loadingTable = false;
        });
    },
    goToCreate() {
      this.$router.push({ name: "new_truck" });
    },
    downloadWithAxios(url, code, ext) {
      axios({
        method: "get",
        url: url,
        responseType: "arraybuffer"
      })
        .then(response => {
          this.forceFileDownload(response, code, ext);
        })
        .catch(e => {
          console.log("error occured");
          console.log(e.message);
        });
    },
    forceFileDownload(response, code, ext) {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", code + "." + ext); //or any other extension
      document.body.appendChild(link);
      link.click();
    },
    openUploadFiles() {
      this.uploadFileDialog = true;
    },
    closeUploadFilesDialog() {
      setTimeout(() => {
        this.selectedGalery = Object.assign({}, {});
        this.$refs.form.reset();
      }, 500);
      this.uploadFileDialog = false;
    },
    async uploadFiles() {
      this.sending = true;
      if (!this.$refs.form.validate()) return;
      try {
        let body = {
          name: this.selectedGalery.name
        };
        if (this.selectedGalery.file)
          body = { ...body, file: this.selectedGalery.file };
        await RestResourceGalery.prototype.postGalery(body);
        this.closeUploadFilesDialog();
      } catch (error) {
        this.errorAlert = true;
        this.errorMsg = error.response.data.message;
        this.closeUploadFilesDialog();
      } finally {
        await this.initialize();
        this.sending = false;
      }
    },
    // Drag and drop images to reorder
    onImageDrop(dropPayload, dropResult) {
      // console.log(dropResult);

      // Prevenir que no se arrastre fuera del grupo de imagenes
      const dropData =
        dropResult.addedIndex == null || dropResult.addedIndex == undefined
          ? {
              removedIndex: dropResult.removedIndex,
              addedIndex: dropResult.removedIndex
            }
          : dropResult;
      const currentPictureUrls = this.trucks[dropPayload.productIndex]
        .pictureUrls;
      const reorderedPictureurls = applyDrag(currentPictureUrls, dropData);

      this.trucks[dropPayload.productIndex].pictureUrls = reorderedPictureurls;

      // Send to backend here
      getAPI.put("api/rest/v1/truck/" + dropPayload.productId, {
        pictureUrls: reorderedPictureurls
      });
    },
    productPos(id) {
      let productPos = 0;

      this.trucks.find((trucks, index) => {
        if (trucks._id == id) {
          productPos = index;

          return trucks._id == id;
        }
      });

      return productPos;
    },
    // Remove process
    setImageRemoveFrom(productId, index) {
      const picture = this.trucks[this.productPos(productId)].pictureUrls[
        index
      ];
      this.imageToRemove = `${this.staticUrl}/${productId}/${picture}`;
      this.imageRemoveFrom = { productId: productId, index: index };
      this.dialogRemoveImage = true;
    },
    removeImage(productId, index) {
      const productIndex = this.productPos(productId);

      this.loadingRemoving = true;
      getAPI
        .put("api/rest/v1/truck/" + productId, {
          pictureUrls: this.trucks[productIndex].pictureUrls
        })
        .then(() => {
          this.trucks[productIndex].pictureUrls.splice(index, 1);
          this.loadingRemoving = false;
          this.dialogRemoveImage = false;
        });
    },
    setTruckToRemove(productId) {
      this.truckToRemove = productId;
      this.dialogRemoveTruck = true;
    },
    removeTruck() {
      const url = "api/rest/v1/galery/" + this.truckToRemove;

      this.loadingRemovingTruck = true;
      getAPI.delete(url).then(() => {
        this.loadingRemovingTruck = false;
        this.dialogRemoveTruck = false;
        this.initialize();
      });
    }
  }
};
</script>

<style scoped>
.custom-th {
  font-size: 0.6rem;
}
.top-btn-driver {
  width: 30%;
  font-size: 0.73rem;
}

@media (max-width: 520px) {
  .top-btn-box {
    flex-direction: column;
  }
  .top-btn-driver {
    margin-bottom: 0.5rem;
    width: 100%;
    font-size: 0.8rem;
  }
}

.dnd-container {
  max-width: 320px;
  overflow-x: auto;
}

.dnd-container .remove-button {
  position: relative;
}

.dnd-container .remove-button .v-btn {
  position: absolute;
  right: 0;
  top: 0;
  border-bottom-left-radius: 5px !important;
}

/* For drag & drop */
.opacity-ghost {
  transition: transform 0.18s ease, opacity 0.18s ease;
  opacity: 0.8;
  transform: rotateZ(8deg);
  box-shadow: 3px 3px 10px 3px rgba(0, 0, 0, 0.3);
}

.opacity-ghost .v-btn {
  display: none;
}

.opacity-ghost-drop {
  opacity: 1;
  transform: rotateZ(0deg);
  box-shadow: 3px 3px 10px 3px rgba(0, 0, 0, 0);
}
</style>
